import _ from 'lodash';
import rules from '../../util/pageRules';

/**
 * Determines if Intercom chat should be enabled for the current user and location.
 * @param {Object} user - The user object
 * @param {string} user._id - User ID
 * @param {boolean} user.chatOff - Whether chat is disabled for this user
 * @param {string} pathname - Current location pathname
 * @returns {boolean} Whether Intercom should be enabled
 */
export function isIntercomEnabled(user, pathname) {
  if (!user || !user._id || user._id === 'temp') {
    return false;
  }

  if (user.chatOff) {
    return false;
  }

  if (rules.isWallboard(pathname)) {
    return false;
  }

  return true;
}

const STREAMS = {
  activities: 'streams/activities',
  cards: 'streams/cards',
  blocked: 'streams/blocked',
  cfActivities: 'streams/cfactivities',
};
const NO_TIMING = { wait_ms: null, download_ms: null, bytes: null };

export function isStreamRequest(entry) {
  return _.some(STREAMS, (pathPart) => _.includes(entry.name, pathPart));
}

export function requestTiming(entries, pathPart) {
  const entry = _.findLast(entries, (e) => _.includes(e.name, pathPart));
  if (!entry) {
    return null;
  }

  return {
    wait_ms: Math.round(entry.responseStart - entry.requestStart),
    download_ms: Math.round(entry.responseEnd - entry.responseStart),
    bytes: entry.encodedBodySize,
  };
}

function msSince(start, end) {
  return end === undefined ? null : Math.round(end - start);
}

export function loadTimings(load) {
  const requests = _.filter(load.entries, (e) => e.startTime >= load.start && e.responseEnd <= load.dataArrived);
  const properties = {
    dashboard_id: load.dashboardId,
    data_ms: msSince(load.start, load.dataArrived),
    render_ms: msSince(load.dataArrived, load.end),
    sync_wait_ms: msSince(load.start, load.syncReady),
    analysis_ms: msSince(load.analysisStart, load.analysisEnd),
  };

  _.forEach(_.pickBy(load.data, _.isArray), (records, name) => {
    properties[`${_.snakeCase(name)}_count`] = records.length;
  });
  _.forEach(STREAMS, (pathPart, name) => {
    _.forEach(requestTiming(requests, pathPart) || NO_TIMING, (value, key) => {
      properties[`${_.snakeCase(name)}_${key}`] = value;
    });
  });

  return properties;
}
